import React, { createContext, useContext, useRef } from 'react';

type IntroHandoffContextValue = {
  taglineRef: React.RefObject<HTMLDivElement | null>;
};

const IntroHandoffContext = createContext<IntroHandoffContextValue | null>(null);

export function IntroHandoffProvider({ children }: { children: React.ReactNode }) {
  const taglineRef = useRef<HTMLDivElement | null>(null);
  return (
    <IntroHandoffContext.Provider value={{ taglineRef }}>
      {children}
    </IntroHandoffContext.Provider>
  );
}

export function useIntroHandoff() {
  const ctx = useContext(IntroHandoffContext);
  if (!ctx) {
    throw new Error('useIntroHandoff must be used within IntroHandoffProvider');
  }
  return ctx;
}
